import { render, staticRenderFns } from "./brandMemberCenter.vue?vue&type=template&id=560afb3b&scoped=true"
import script from "./brandMemberCenter.vue?vue&type=script&lang=js"
export * from "./brandMemberCenter.vue?vue&type=script&lang=js"
import style0 from "./brandMemberCenter.vue?vue&type=style&index=0&id=560afb3b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560afb3b",
  null
  
)

export default component.exports